export default "__VITE_ASSET__af15aa48__"